const formats = {
  USD: {
    standard: new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', notation: 'standard' }),
    compact: new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', notation: 'compact' }),
    withPrecision: new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      notation: 'standard',
      maximumSignificantDigits: 5,
    }),
  },
  BRL: {
    standard: new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL', notation: 'standard' }),
    compact: new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL', notation: 'compact' }),
    withPrecision: new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
      notation: 'standard',
      maximumSignificantDigits: 5,
    }),
  },
  EUR: {
    standard: new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', notation: 'standard' }),
    compact: new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', notation: 'compact' }),
    withPrecision: new Intl.NumberFormat('de-DE', {
      style: 'currency',
      currency: 'EUR',
      notation: 'standard',
      maximumSignificantDigits: 5,
    }),
  },
}

export function currencyFormatter(currency = 'USD', format = 'standard') {
  const currencyFormats = formats[currency]
  if (!currencyFormats) throw new TypeError(`Invalid currency. Valid values are: ${Object.keys(formats)}`)

  const currencyFormat = currencyFormats[format]
  if (!currencyFormat) throw new TypeError(`Invalid format. Valid values are: ${Object.keys(currencyFormats)}`)

  return currencyFormat.format
}

export const usdFormat = currencyFormatter('USD', 'standard')
export const usdFormatCompact = currencyFormatter('USD', 'compact')
export const usdFormatWithPrecision = currencyFormatter('USD', 'withPrecision')
